import React, { useEffect } from 'react';
import Immutable from 'immutable';
import { useSelector, useDispatch } from 'react-redux';
import {
  Node,
  Taxonomy as TaxonomyTerm,
  entityGetByPath,
  ContextualActionsWrapper,
} from '@uncinc/react-drupal-core';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';
import {
  vacancyURLIdentifier,
} from '../../helpers';

import {
  HTTP_CODE_NOT_FOUND,
  HTTP_CODE_GONE
} from '../../config/constants';

import {
  Webform,
  WebformSelect,
} from '../../components';

import Page from '../Page';
import NotFound from '../NotFound';
import Forbidden from '../Forbidden';
import Header from '../../components/Header';
import { usePrevious } from '../../helpers/usePrevious';

const Entity = () => {
  const dispatch = useDispatch();
  const entityId = useSelector((state) => state.getIn(['entity', 'entityId'], null));
  const entityType = useSelector((state) => state.getIn(['entity', 'entityType'], null));
  const childEntity = useSelector((state) => state.getIn([entityType, entityId], Immutable.Map()));
  const path = useSelector((state) => state.getIn(['router', 'location', 'pathname']));
  const entityStatus = useSelector((state) => state.getIn(['entity', 'status']));
  const entityExists = useSelector((state) => state.getIn(['entity', 'exists'], null));

  const currentEntityId = useSelector((state) => state.getIn(['entity', 'entityId'], null));
  const currentTaxonomyHasPage = useSelector((state) => state.getIn(['taxonomyTerm', currentEntityId, 'field_has_municipality_page', 0, 'value']));
  const currentWebformIsArchived = useSelector((state) => state.getIn(['webform', currentEntityId, 'info', 'archive'], false));

  const prevPath = usePrevious(path);
  const entityNotLoaded = !entityType || !entityId;
  const pathIsDifferentAndHasEntity = (path !== prevPath && typeof prevPath !== 'undefined') && (typeof entityStatus !== 'undefined' && entityStatus !== null);

  useEffect(() => {
    if (entityNotLoaded || (!entityNotLoaded && pathIsDifferentAndHasEntity)) {
      dispatch(entityGetByPath(path));
    }
  }, [dispatch, entityNotLoaded, pathIsDifferentAndHasEntity, path]);

  if ((!entityType || !entityId) && entityExists) {
    return null;
  }
  const isTaxonomyTerm = entityType === 'taxonomy_term';

  const renderPage = () => {
    if (entityStatus === 403 && !window.location.href.includes(vacancyURLIdentifier)) {
      return (
        <Container>
          <Header />
          <Forbidden />
        </Container>
      );
    }

    if (
      (entityStatus === HTTP_CODE_NOT_FOUND) ||
      (entityStatus === HTTP_CODE_GONE) ||
      (isTaxonomyTerm && currentTaxonomyHasPage === false) ||
      (entityType === 'webform' && currentWebformIsArchived)
    ) {
      return (
        <Container>
          <Header />
          <NotFound />
        </Container>
      );
    }

    return (
      <ContextualActionsWrapper>
        <Page title={childEntity.getIn(['title', 0, 'value'], '')} path={path} prevPath={prevPath}>
          {entityType === 'node' && (
            <Node root id={entityId} />
          )}
          {isTaxonomyTerm && (
            <TaxonomyTerm root id={entityId} />
          )}
          {entityType === 'webform' && (
            <Container small>
              <Webform root id={entityId} overriddenComponents={{ select: WebformSelect }} />
            </Container>
          )}
        </Page>
      </ContextualActionsWrapper>
    );
  };

  return (
    <div>
      {renderPage()}
    </div>
  );
};

export default Entity;
